import { useState, useEffect } from 'react';
import { css, cx } from '@eti/styles';
import { loadLogo } from './Utils';
import { jsx as _jsx } from "react/jsx-runtime";
const buttonStyles = css`
  appearance: none;
  background: transparent;
  border: 0;
  cursor: pointer;
  height: 100%;
  outline: none;
  padding: 0;
  width: 100%;
`;
const BrandLogo = ({
  onClick,
  ...props
}) => {
  const [logo, setLogo] = useState(/*#__PURE__*/_jsx("div", {}));
  const {
    brand,
    siteName,
    shouldUseContrast,
    className,
    'data-testid': dataTestId
  } = props;
  useEffect(() => {
    let isCancelled = false;
    const getLogo = async () => {
      try {
        const brandLogo = await loadLogo({
          brand,
          siteName,
          shouldUseContrast,
          className,
          dataTestId
        });
        if (!isCancelled) {
          setLogo(brandLogo);
        }
      } catch (error) {
        if (!isCancelled) {
          console.warn(`Error fetching logo for brand: [${brand}]. [Error]: ${error}`); // oxlint-disable-line no-console
        }
      }
    };
    getLogo();
    return () => {
      isCancelled = true;
    };
  }, [brand, shouldUseContrast, siteName, className, dataTestId]);
  return onClick ? /*#__PURE__*/_jsx("button", {
    className: cx('etiBrandLogo__trigger', buttonStyles),
    onClick: onClick,
    type: "button",
    children: logo
  }) : logo;
};
export default BrandLogo;
//# sourceMappingURL=BrandLogo.js.map